import Axios from "axios";
import {SET_LEAVE_BALANCE_LIST, UNSET_LEAVE_BALANCE_LIST, SET_EMPLOYEE_LEAVE_BALANCE_LIST, UNSET_EMPLOYEE_LEAVE_BALANCE_LIST } from "@/store/mutation-types";

import {
  leaveBalance as leaveBalanceApi,
  employeeLeaveBalance as employeeLeaveBalanceApi,
} from "@/store/api";

const state = {
    getLeaveBalanceList: [],
    getEmployeeLeaveBalanceList: [],
};


const getters = {
    getLeaveBalanceList(state) {
        return state.getLeaveBalanceList;
    },
    getEmployeeLeaveBalanceList(state) {
        return state.getEmployeeLeaveBalanceList;
    },
};



// Mutations
const mutations = {
    [SET_LEAVE_BALANCE_LIST](state, data) {
        state.getLeaveBalanceList = data;
    },
    [UNSET_LEAVE_BALANCE_LIST](state) {
        state.getLeaveBalanceList = [];
    },

    [SET_EMPLOYEE_LEAVE_BALANCE_LIST](state, data) {
        state.getEmployeeLeaveBalanceList = data;
    },
    [UNSET_EMPLOYEE_LEAVE_BALANCE_LIST](state) {
        state.getEmployeeLeaveBalanceList = [];
    },
};


// Actions
const actions = {

  getLeaveBalanceList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${leaveBalanceApi}`, { params: data })
        .then((response) => {
          commit(SET_LEAVE_BALANCE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_LEAVE_BALANCE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getEmployeeLeaveBalanceList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${employeeLeaveBalanceApi}`, { params: data })
        .then((response) => {
          commit(SET_EMPLOYEE_LEAVE_BALANCE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_LEAVE_BALANCE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

};


export default {
  state,
  getters,
  actions,
  mutations,
};